import React from 'react';
import './PlaceholderPage.css';

const ShopifyIntegrationPage = () => {
  return (
    <div className="placeholder-page">
      <h1 className="page-title">Shopify Integration</h1>
      <p className="page-description">
        Shopify marketplace integration settings will be added here.
      </p>
    </div>
  );
};

export default ShopifyIntegrationPage;
